// extracted by mini-css-extract-plugin
export default {"numberContainer":"NumberInput_numberContainer__oHRy6","numberInput":"NumberInput_numberInput__FEs6y"};